import styled from 'styled-components'
import { device } from '../responsive'




export const Container = styled.div`
    background-color: #2F2E41;
    padding: 75px 30px;
    @media screen and ${device.mobile} {
        padding: 50px 30px;
    }
    @media screen and ${device.xsmobile} {
        padding: 30px 20px;
    }
`
export const Title = styled.h2`
    text-align: center;
    font-size: 29px;
    font-weight: 600;
    margin-bottom: 1rem;
    margin-top: 0rem;
    text-transform: uppercase;
    // color: #2F2E41;
    color: #fff;
    @media screen and ${device.mobile} {
        font-size: 20px;
    }  
`
export const Hr = styled.div`
    margin: auto;
    width: 40px;
    height: 3px;
    background-color: #ffffff;
    margin-bottom: 50px;
    
    @media screen and ${device.mobile} {
        margin-bottom: 40px;
    }
`
export const Wrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
   
`

export const LeftColumn = styled.div`
    flex: 1 1 auto;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45%;
    max-width: 550px;
  
        
    
    @media screen and ${device.tablet} {
        display: none;
    }
`

export const Image = styled.img`
    max-width: 100%;
    height: auto;
    max-height: 100%;
    
`

export const RightColumn = styled.div`
            
            flex: 1 1 auto;
            padding: 10px;
            box-sizing: border-box;
            width: 55%;
            max-width: 650px;
            align-items: center;
            justify-content: center;
            display: flex;
            flex-direction: column;
    
    
    
    @media screen and ${device.mobile} {
        padding: 10px 0px;
      
    }
`


export const Header = styled.h3`
    font-size: 21px;
    font-weight: 500;
    margin-bottom: 40px;
    // color: #2F2E41;
    color: #fff;

    @media screen and ${device.mobile} {
        font-size: 18px;
    }   
`
export const Text = styled.p`
    font-size: 18px;
    font-weight: 500;
    margin-top: 0px;
    margin-bottom: 16px;
    padding-right: 15px;
    // text-align: justify;
    line-height: 27px;
    letter-spacing: 0.4px;
    color: #fff;

    &:nth-child(3) {
        margin-bottom: 0px;
    }

    @media screen and ${device.mobile} {
        padding-right: 0px;
        font-size: 15px;
    }
`

export const Bold = styled.span`
    font-weight: 700;
    // color: #ffffff;
    color: #F5D76E;
`



